import availableShiftUrl from './tips/availableShift.html';
import unassignedShiftUrl from './tips/unassignedShift.html';
import multiselectShiftsUrl from './tips/multiselectShifts.html';
import copySchedulesUrl from './tips/copySchedules.html';
import shiftsTipsComponentUrl from './shiftsTipsComponent.html';
class ShiftsTipsCtrl {
  constructor(Authentication, ShiftsEducation, $scope, $sce) {
    'ngInject';

    Object.assign(this, { Authentication, ShiftsEducation, $scope, $sce });
  }

  $onInit() {
    if (this.clientFlags.shiftsEducationCompleted) {
      return;
    }

    this.tips = [
      {
        shownFlag: 'shiftsTutorialAvailableShiftsShown',
        url: this.$sce.trustAsHtml(availableShiftUrl),
        skip: (flags) => flags.shiftsAvailableShiftHasBeenCreated,
      },
      {
        shownFlag: 'shiftsTutorialUnassignedShiftsShown',
        url: this.$sce.trustAsHtml(unassignedShiftUrl),
        skip: (flags) => flags.shiftsUnassignedShiftHasBeenCreated,
      },
      {
        shownFlag: 'shiftsTutorialMultiselectShown',
        url: this.$sce.trustAsHtml(multiselectShiftsUrl),
        skip: (flags) => flags.shiftsMultiselectHasBeenUsed,
      },
      {
        shownFlag: 'shiftsTutorialCopySchedulesShown',
        url: this.$sce.trustAsHtml(copySchedulesUrl),
        skip: (flags) => flags.shiftsCopyBetweenWeeksHasBeenUsed,
      },
    ];

    this.shiftEducationTipInterval = 5;
    this.setTip();
    this.$scope.$on(
      '$destroy',
      this.ShiftsEducation.onUpdate(() => this.setTip())
    );
  }

  get clientFlags() {
    return this.Authentication.user.settings.clientFlags;
  }

  setTip() {
    // is the user is a plain employee - ignore this completely
    if (!this.Authentication.user.isManager) {
      return;
    }

    // if the user hasn't completed onboarding yet - do not overwhelm with tips
    if (!this.Authentication.user.settings.adminOnboardingCompleted) {
      return;
    }

    // if no tip is shown and we created at least 5 shifts since last tip was closed
    if (
      !this.clientFlags.shiftsEducationShowTip &&
      this.clientFlags.numberOfShiftsCreated - this.clientFlags.shiftsEducationLastUnlock <
        this.shiftEducationTipInterval
    ) {
      return;
    }

    const currentTip = this.tips.find((tip) => {
      if (this.clientFlags[tip.shownFlag]) {
        return false;
      }

      if (tip.skip(this.clientFlags)) {
        this.clientFlags[tip.shownFlag] = true;
        return false;
      }

      return true;
    });

    if (!currentTip) {
      // if we got here and didn't find any tip to show then it means we shown them all
      this.clientFlags.shiftsEducationCompleted = true;
    } else {
      this.currentTip = currentTip;
      this.clientFlags.shiftsEducationShowTip = true;
    }

    this.Authentication.syncSettings();
  }

  closeTip() {
    // remember how many shifts where created so far when closing current tip
    this.clientFlags.shiftsEducationLastUnlock = this.clientFlags.numberOfShiftsCreated;

    // mark current tip as shown
    this.clientFlags[this.currentTip.shownFlag] = true;

    this.clientFlags.shiftsEducationShowTip = false;
    this.Authentication.syncSettings();
  }
}

export default {
  controller: ShiftsTipsCtrl,
  controllerAs: 'ctrl',
  templateUrl: shiftsTipsComponentUrl,
};
